import axios from 'axios'

export default() => {
  return axios.create({
    baseURL: `http://sport.st-georgia.ge/assets/php/api.php`, // local
    // baseURL: `https://sport.infotronic.by/assets/php/api.php`, // local
    // baseURL: `assets/php/`, // server
    withCredentials: false,
    headers: {
      'Access-Control-Allow-Origin': 'http://localhost:8080',
      'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE',
      'Access-Control-Allow-Headers': 'Content-Type',
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/services/Api.js